import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'circular-progress-bar',
  template: `
      <div class="circle-container">
        <div class="text-indicator-wrapper">
          <span class="percent-indicator">{{this.percentage}}%</span>
          <span class="text-indicator eva-3-caption">{{'wizumen.percent' | translate}}</span>
        </div>
        <svg class="svg-indicator" [ngStyle]="{'width': this.sizeBar + 'px', 'height': this.sizeBar + 'px'}">
          <circle class="svg-indicator-track" [attr.cx]="cx" [attr.cy]="cy" [attr.r]="radius" fill="transparent" stroke-width="4" stroke-linecap="round"></circle>
          <circle class="svg-indicator-indication" [attr.cx]="cx" [attr.cy]="cy" [attr.r]="radius" fill="transparent" stroke-width="4" stroke-linecap="round" [attr.stroke-dasharray]="this.circumference" [attr.stroke-dashoffset]="this.strokeDashoffset"></circle>
        </svg>
      </div>
  `,
  styleUrls: ['./circular-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CircularProgressBarComponent implements OnInit {
  @HostBinding("style.--sizeBar")
  @Input() sizeBar:number;
  @Input() totalItems: number;
  @Input() activeItems: number;

  cy: number;
  cx: number;
  percentage: number;
  radius: number;
  circumference: number;
  strokeDashoffset: number;
  strokeDasharray: number;

  ngOnInit(): void {
    this.percentage = Math.round((this.activeItems / this.totalItems) * 100);
    this.radius = (this.sizeBar - 4) / 2;
    this.cx = this.sizeBar / 2;
    this.cy = this.sizeBar / 2;
    this.circumference = Math.round(this.radius * 2 * 3.14)
    this.strokeDashoffset = Math.round((1 - this.percentage / 100) * this.circumference);
  }
}
